import { AdvancedSearchEntityType, BridgeEntityResult } from "generated/graphql";

export const availableEntityTypes = (
    entityTypes: AdvancedSearchEntityType[],
    entities: Pick<BridgeEntityResult, "name">[],
): AdvancedSearchEntityType[] =>
    entityTypes.filter(entityType => entities.some(e => e.name === entityType));

export interface EntityTypeOption {
    value: AdvancedSearchEntityType;
    label: string;
}

export const entityTypeOptions = (
    entityTypes: AdvancedSearchEntityType[],
    entities: Pick<BridgeEntityResult, "name" | "title">[],
): EntityTypeOption[] =>
    availableEntityTypes(entityTypes, entities)
        .map(entityType => ({
            value: entityType,
            label: entities.find(e => e.name === entityType)?.title || entityType,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

export const resolveSelectedEntityType = (
    available: AdvancedSearchEntityType[],
    preferred: AdvancedSearchEntityType | null,
): AdvancedSearchEntityType | null =>
    available.find(entityType => entityType === preferred) ?? available[0] ?? null;
